<div class="flex flex-col bg-pet-gray-2 w-[600px] rounded-lg py-1 px-12 py-10">
    <h2 class="text-2xl w-full text-pet-color-text-1 font-bold text-center">Ahora confirmemos tu correo electrónico.</h2>
  <mat-dialog-content class="w-full">
    <div class="text-pet-color-text-1 font-semibold text-center">
        Hemos enviado un código de confirmación a tu dirección de correo electrónico. <span class="text-cyan-500">{{data.email}}</span><br> 
        Por favor, introduce el código para continuar.
        Por favor NO cierres esta ventana.
    </div>  

    <form class="form flex flex-col w-full gap-3 justify-center items-center my-4"
    #otpSignUp="ngForm" [formGroup]="otpSignUpForm">
        <input type="text"
        [formControlName]="'otp'"
        [ngClass]="{'border-red-500': otpSignUpForm.get('otp').invalid && clickConfirm}"
        class="w-full bg-gray-50 border-2 text-center border-pet-color-text-1 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-3.5 pl-6 text-pet-color-text-1 placeholder-pet-color-text-1"
        placeholder="# # # # # #" required>
        <span class="text-red-500 text-sm pl-2" *ngIf="otpSignUpForm.get('otp').hasError('required') && clickConfirm">
            este campo es requerido
        </span>
    </form>


  </mat-dialog-content>
  <mat-dialog-actions class="flex gap-3">
    <button class="flex-1 bg-green-500 w-full text-white font-semibold py-2 px-5 hover:bg-green-300 rounded" (click)="onNoClick()" cdkFocusInitial>Confirmar</button>
  </mat-dialog-actions>

</div>